export default class PriorityEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#priority_uuid") ? (elem.querySelector("#priority_uuid") as HTMLInputElement).value : null,
            name: (elem.querySelector("#priority_name") as HTMLInputElement).value,
            color: (elem.querySelector("#priority_color") as HTMLInputElement).value,
        }
    }
}